import { ISimilarPatient } from '@ispm-client/modules/similar-patients/models/similar-patient.interface';

export const NO_SP_CHANGE = null;

export interface SimilarPatientsDataState {
  currentPatient: ISimilarPatient | null;
  patientsData: Map<any, any[]>;
  stateSuccess: any | null; // in case of a successful event, this value holds the exact event's type on which this event
                            // occurs: { stateType: StateTypes }
  error: any | null; // in case of an error, this value holds the exact event's type on which this event occurs &
                          // the exact error value: { stateType: StateTypes, error: any }
}

export const initialState: SimilarPatientsDataState = {
  currentPatient: null,
  patientsData: new Map(),
  stateSuccess: null,
  error: null
};

export function buildSimilarPatientsKeys(actionPayloadKey: any) {

  if (typeof actionPayloadKey === 'object') {
    return JSON.stringify(actionPayloadKey);
  }

  return actionPayloadKey;
}

